import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import cn from 'classnames';
import { ArrowDown, ArrowUp, EyeHidden, Kebab, Lock } from '../../../../icons';
import { getTestIds } from '../../../../utils/TestIds';
import { useBiAction } from '../../../BiTracking';
import { DropdownMenu, DropdownMenuItem } from '../../../DropdownMenu';
import { IconButton } from '../../../IconButton';
import { Typography } from '../../../Typography';
import { MENU_ICON_SIZE } from '../table.constants';
import styles from '../table.module.scss';
import { TableSortIcon } from '../TableSortIcon';
export function TableHeaderCell(props) {
    const { id, label, frozen, locked, sortable, hAlign, plainLabel, labelVariant = 'paragraph3', sortDirection, width, isLastFrozen, isScrolledX, left, columnMenu, onSortClick, onToggleFrozen, onHideColumn, onResizeStart, testId, dragHandle, isDragOverlay, trailing = false } = props;
    const testIds = getTestIds(testId);
    const logBiAction = useBiAction();
    const { bi } = props;
    const sortColumn = (direction)=>{
        const sortsTo = direction !== null && direction !== void 0 ? direction : sortDirection === 'desc' ? 'asc' : 'desc';
        if (bi != null) {
            logBiAction({
                entityType: 'table_sort',
                entityName: "sort_".concat(bi.name),
                actionType: 'click',
                data: _object_spread_props(_object_spread({}, bi.data), {
                    sortDirection: sortsTo
                })
            });
        }
        onSortClick === null || onSortClick === void 0 ? void 0 : onSortClick(id, direction);
    };
    return /*#__PURE__*/ _jsxs("div", {
        "data-colid": id,
        "data-testid": testIds.column(id),
        className: cn(styles.headerCell, {
            [styles.interactive]: sortable || columnMenu != null || onResizeStart != null,
            [styles.trailingCell]: trailing,
            [styles.frozen]: frozen && isDragOverlay !== true,
            [styles.scrolledFrozenEdge]: isLastFrozen && isScrolledX
        }),
        style: {
            width,
            left: frozen && isDragOverlay !== true ? left : undefined
        },
        children: [
            locked !== true && dragHandle,
            /*#__PURE__*/ _jsxs("div", {
                className: cn(styles.headerLabel, {
                    [styles.sortable]: sortable,
                    [styles.alignEnd]: hAlign === 'end',
                    [styles.alignCenter]: hAlign === 'center'
                }),
                onClick: ()=>sortable && sortColumn(),
                "data-testid": testIds.label(id),
                children: [
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: plainLabel ? 'paragraph1' : labelVariant,
                        skin: plainLabel ? undefined : 'secondary',
                        ellipsis: true,
                        children: label
                    }),
                    sortable && /*#__PURE__*/ _jsx(TableSortIcon, {
                        direction: sortDirection,
                        testId: testIds.sort(id)
                    })
                ]
            }),
            columnMenu != null && /*#__PURE__*/ _jsxs(DropdownMenu, {
                target: /*#__PURE__*/ _jsx(IconButton, {
                    bi: columnMenu.bi.trigger,
                    size: "small",
                    aspect: "square",
                    className: styles.columnMenuTrigger,
                    testId: testIds.menu(id),
                    children: /*#__PURE__*/ _jsx(Kebab, {
                        size: 16
                    })
                }),
                testId: testIds.menuList(id),
                children: [
                    sortable && /*#__PURE__*/ _jsx(DropdownMenuItem, {
                        bi: columnMenu.bi.sortAscending,
                        iconStart: /*#__PURE__*/ _jsx(ArrowUp, {
                            size: MENU_ICON_SIZE
                        }),
                        onClick: ()=>sortColumn('asc'),
                        testId: testIds.sortAscending(id),
                        children: columnMenu.labels.sortAscending
                    }),
                    sortable && /*#__PURE__*/ _jsx(DropdownMenuItem, {
                        bi: columnMenu.bi.sortDescending,
                        iconStart: /*#__PURE__*/ _jsx(ArrowDown, {
                            size: MENU_ICON_SIZE
                        }),
                        onClick: ()=>sortColumn('desc'),
                        testId: testIds.sortDescending(id),
                        children: columnMenu.labels.sortDescending
                    }),
                    !locked && /*#__PURE__*/ _jsx(DropdownMenuItem, {
                        bi: columnMenu.bi.freeze,
                        iconStart: /*#__PURE__*/ _jsx(Lock, {
                            size: MENU_ICON_SIZE
                        }),
                        onClick: ()=>onToggleFrozen === null || onToggleFrozen === void 0 ? void 0 : onToggleFrozen(id),
                        testId: testIds.freeze(id),
                        children: frozen ? columnMenu.labels.unfreeze : columnMenu.labels.freeze
                    }),
                    !locked && /*#__PURE__*/ _jsx(DropdownMenuItem, {
                        bi: columnMenu.bi.hide,
                        iconStart: /*#__PURE__*/ _jsx(EyeHidden, {
                            size: MENU_ICON_SIZE
                        }),
                        onClick: ()=>onHideColumn === null || onHideColumn === void 0 ? void 0 : onHideColumn(id),
                        testId: testIds.hide(id),
                        children: columnMenu.labels.hide
                    })
                ]
            }),
            onResizeStart != null && /*#__PURE__*/ _jsx("div", {
                className: styles.resizeHandle,
                "data-testid": testIds.resize(id),
                onMouseDown: (event)=>{
                    event.stopPropagation();
                    onResizeStart(id, event);
                }
            })
        ]
    });
}
